import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
  selector: 'icon-menu-user-plus',
  standalone: true,
  imports: [CommonModule],
  template: `
    <ng-template #template>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="class">
        <path
          opacity="0.5"
          d="M18 17.5C18 19.9853 18 22 10 22C2 22 2 19.9853 2 17.5C2 15.0147 5.58172 13 10 13C14.4183 13 18 15.0147 18 17.5Z"
          fill="currentColor"
        />
        <circle cx="10" cy="6" r="4" fill="currentColor" />
        <rect x="17" y="9.25" width="4" height="1.5" rx="0.75" fill="currentColor" />
        <rect x="18.25" y="8" width="1.5" height="4" rx="0.75" fill="currentColor" />
      </svg>
    </ng-template>
  `,
})
export class IconMenuUserPlusComponent {
  @Input() class: any = '';
  @ViewChild('template', { static: true }) template: any;
  constructor(private viewContainerRef: ViewContainerRef) {}
  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
    this.viewContainerRef.element.nativeElement.remove();
  }
}
